<template>
  <v-card
    class="warranty-dialog"
  >
    <v-card-title class="warranty-dialog__close pa-0">
      <v-btn
        icon
      >
        <v-icon
          small
          @click="$emit('close', true)"
        >
          close
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text
      class="pa-0 warranty-dialog__title"
    >
      Garantia Estendida
    </v-card-text>

    <v-card-text
      class="pa-0 my-1 mb-2 warranty-dialog__txt"
    >
      Saiba como proteger seu produto por muito mais tempo.
    </v-card-text>

    <v-card-text
      class="pa-0 my-1 mb-3 warranty-dialog__sub"
    >
      Selecione o prazo de proteção
      <a
        target="_blank"
        href="https://vuetifyjs.com"
      >
        SEGURO GARANTIA ESTENDIDA
      </a>
      e mantenha seu produto protegido por mais tempo além da garantia oferecida pelo fabricante, você conta com vantagens exclusivas.
    </v-card-text>

    <v-form
      v-model="valid"
    >
      <v-container
        fluid
        class="dialog-container"
      >
        <!-- Desabilitado para V0 (por padrão vem a opção todas as unidades selecionadas) -->
        <!-- <v-autocomplete
          v-if="quantity > 1"
          v-model="unitiesToApply"
          :items="getQuantities"
          label="Para quantas unidades deseja aplicar?"
          required
        /> -->

        <v-radio-group v-model="selectedWarranty">
          <v-radio
            class="dialog-radio"
            color="#140C22"
            :value="null"
          >
            <template #label>
              <div class="dialog-radio__wrapper">
                <span
                  class="dialog-radio__wrapper__title"
                >
                  Sem garantia estendida
                </span>
                <span
                  class="dialog-radio__wrapper__txt"
                >
                  Somente garantia do fabricante
                </span>
              </div>
            </template>
          </v-radio>
          <v-radio
            v-for="(warranty, index) in otherWarranties"
            :key="index"
            :value="warranty"
            class="dialog-radio"
            color="#140C22"
          >
            <template #label>
              <div class="dialog-radio__wrapper">
                <span
                  class="dialog-radio__wrapper__title"
                >
                  {{ warranty.title }}
                </span>
                <span
                  class="dialog-radio__wrapper__txt"
                >
                  {{ warranty.subtitle }}
                </span>
              </div>
              <div class="dialog-radio__wrapper">
                <span
                  class="dialog-radio__wrapper__title"
                >
                  {{ warranty.price | currency }}
                </span>
                <span
                  class="dialog-radio__wrapper__txt"
                >
                  {{ warranty.installments }}
                </span>
              </div>
            </template>
          </v-radio>
          <span
            class="advise"
          >
            Recomendado
          </span>
          <v-radio
            :value="recommendedWarranty"
            class="dialog-radio"
            color="#140C22"
            style="border: 1px solid #140C22"
            mandatory
          >
            <template #label>
              <div class="dialog-radio__wrapper">
                <span
                  class="dialog-radio__wrapper__title"
                >
                  {{ recommendedWarranty.title }}
                </span>
                <span
                  class="dialog-radio__wrapper__txt"
                >
                  {{ recommendedWarranty.subtitle }}
                </span>
              </div>
              <div class="dialog-radio__wrapper">
                <span
                  class="dialog-radio__wrapper__title"
                >
                  {{ recommendedWarranty.price | currency }}
                </span>
                <span
                  class="dialog-radio__wrapper__txt"
                >
                  {{ recommendedWarranty.installments }}
                </span>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-container>

      <!-- to be used in upcoming versions of sales assistant -->
      <!-- <v-container
        fluid
        class="dialog-conditions"
      >
        <v-checkbox
          v-model="selectedTerms"
          color="black"
          :rules="[(v) => !!v || 'Campo Obrigatório!']"
        >
          <template
            #label
            required
          >
            <div
              class=" pl-2 dialog-conditions__txt"
            >
              Li e aceito os
              <a
                target="_blank"
                href="https://vuetifyjs.com"
                class="dialog-conditions__link"
              >
                Termos de acordo
              </a>
              e
              <a
                target="_blank"
                href="https://google.com"
                class="dialog-conditions__link"
              >
                Informações Legais.
              </a>
              Caso não esteja de acordo, proceda sua compra sem a Garantia Estendida Original.
            </div>
          </template>
        </v-checkbox>
      </v-container> -->

      <v-card-actions
        class="warranty-dialog__actions pa-0 ma-0 mt-1"
      >
        <v-btn
          class="warranty-dialog__btn"
          medium
          depressed
          :disabled="!valid"
          color="#140C22"
          @click="addWarranty()"
        >
          Continuar
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import orderBy from 'lodash.orderby';

export default {
  props: {
    product: {
      type: Object,
      default: () => {},
    },
    productIdx: {
      type: Number,
      default: undefined,
    },
    quantity: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    selectedWarranty: null,
    valid: null,
    unitiesToApply: undefined,
  }),

  computed: {
    getSkuAddOns() {
      let skuAddOnsWithRecommended = this.product.skus[0].sku_add_ons.filter((skuAddOn) => skuAddOn.type === 'GE' && skuAddOn.store_id === this.product.store_id).map((skuAddOn) => ({
        sku_add_on_id: skuAddOn.id,
        title: `+ ${skuAddOn.plan} ${skuAddOn.plan > 1 ? 'Meses' : 'Mês'}`,
        subtitle: skuAddOn.description || 'Garantia Estendida',
        price: skuAddOn.price_plan,
        plan: skuAddOn.plan,
        installments: `em até 10x de ${(skuAddOn.price_plan / 10).toFixed(2)}`,
        recommended: false,
      }));

      if (skuAddOnsWithRecommended.length) {
        const skuAddOnWithMaxPlanPrice = skuAddOnsWithRecommended.reduce((prev, current) => ((prev.price > current.price) ? prev : current));
        const skuAddOnWithMaxPlan = skuAddOnsWithRecommended.reduce((prev, current) => ((prev.plan > current.plan) ? prev : current));

        skuAddOnsWithRecommended = skuAddOnsWithRecommended.map((skuAddOn) => ({
          ...skuAddOn,
          recommended: skuAddOn.price === skuAddOnWithMaxPlanPrice.price && skuAddOn.plan === skuAddOnWithMaxPlan.plan,
        }));

        const notRecommended = skuAddOnsWithRecommended.filter((warranty) => !warranty.recommended);

        return notRecommended.length
          ? orderBy(skuAddOnsWithRecommended, 'price')
          : orderBy(skuAddOnsWithRecommended, 'plan');
      }

      return [];
    },

    otherWarranties() {
      return this.getSkuAddOns.filter((warranty) => !warranty.recommended);
    },

    recommendedWarranty() {
      return this.getSkuAddOns.find((warranty) => warranty.recommended);
    },

    getQuantities() {
      const items = [{
        value: this.quantity.length,
        text: 'Todas as unidades',
      }];
      // eslint-disable-next-line no-plusplus
      for (let i = 1; i <= this.quantity; i++) {
        items.push({ value: i, text: i });
      }
      return items;
    },
  },

  watch: {
    product() {
      this.selectedWarranty = this.product.warranty || this.recommendedWarranty;
    },

    quantity() {
      // eslint-disable-next-line prefer-destructuring
      this.unitiesToApply = this.getQuantities[0];
    },
  },

  mounted() {
    this.selectedWarranty = this.product.warranty || this.recommendedWarranty;
    // eslint-disable-next-line prefer-destructuring
    this.unitiesToApply = this.getQuantities[0];
  },

  methods: {
    addWarranty() {
      this.$set(this.product, 'warranty', this.selectedWarranty);
      this.$emit('update-product', this.productIdx, this.product);
      this.$emit('change-quantity-warranty', this.unitiesToApply);
      this.$emit('finish-warranty');
      this.$store.dispatch('refreshCatalogue');
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.warranty-dialog {
  padding: 0px 20px 40px 20px;
  text-transform: none;
  border-radius: 7px;
  color: #140C22;
  box-sizing: border-box;
  &__title {
    font-family: 'Nunito Sans';
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    text-transform: uppercase;
  }
  &__txt {
    font-family: 'Nunito Sans';
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    text-transform: none;
  }
  &__sub {
    font-family: 'Nunito Sans';
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    text-transform: none;
  }
  &__actions {
    align-items: center;
    justify-content: center;
  }
  &__btn {
    width: 290px;
    height: 38px;
    border-radius: 7px;
    text-transform: none;
    font-weight: 600;
    color: #FFFFFF;
  }
  &__close {
    display: flex;
    justify-content: end;
    transform: translateX(15px);
  }
}

.dialog-container {
  padding: 0px;
  width: 100%;
}

.dialog-radio{
  border: 1px solid rgba(20, 12, 34, 0.25);
  border-radius: 7px;
  padding: 0.3rem 1.2rem;
  width: 100%;
  &__wrapper {
    padding: 0.4rem 0.6rem;
    &__title {
      color: #140C22;
      display: block;
      font-family: 'Nunito Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
    }
    &__txt {
      color: #8A8691;
      display: block;
      font-family: 'Nunito Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 10px;
      line-height: 14px;
    }
  }
}

.dialog-conditions {
  padding: 0px;
  margin-top: -30px;
  &__txt {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: rgba(20, 12, 34, 0.5);
  }
  &__link {
    color: #046CB8;
  }
}

::v-deep .dialog-conditions .v-input__slot {
  align-items: flex-start;
}

::v-deep .v-list__tile {
  border-bottom: none;
}

.v-radio {
  margin: 0px;
}

.advise {
  width: 81px;
  height: 19px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 800;
  font-size: 8px;
  line-height: 11px;
  background: #3D6961;
  border-radius: 3px;
  color: #FFFFFF;
  text-transform: uppercase;
}
</style>
